import React, { useEffect, useState } from 'react';
import './style/UserManagementPage.css';
import NavBarAdmin from "./NavBarAdmin";
import config from './config/config';
import { useNavigate } from "react-router-dom";

const SESSION_TIMEOUT = 10 * 60 * 1000; // 5 минут

function CarTemplatesManagementPage() {
    const [brands, setBrands] = useState([]);
    const [models, setModels] = useState([]);
    const [years, setYears] = useState([]);
    const [prices, setPrices] = useState([]);
    const [uploading, setUploading] = useState(false);

    // Фильтры
    const [filterBrand, setFilterBrand] = useState('');
    const [filterModel, setFilterModel] = useState('');
    const [filterYear, setFilterYear] = useState('');
    const [filterPrice, setFilterPrice] = useState('');

    const navigate = useNavigate();

    // Проверка сессии при загрузке
    useEffect(() => {
        const isAuth = localStorage.getItem('adminAuth');
        const loginTime = localStorage.getItem('loginTime');

        if (isAuth && loginTime) {
            const diff = Date.now() - Number(loginTime);
            if (diff > SESSION_TIMEOUT) {
                // сессия истекла
                localStorage.removeItem('adminAuth');
                localStorage.removeItem('loginTime');
                alert('Сессия истекла, пожалуйста, войдите заново.');
                navigate('/panel/admin-panel');
                return;
            }
        } else {
            // если не авторизован
            navigate('/panel/admin-panel');
            return;
        }

        // Загружаем данные после проверки
        fetchData();
    }, [navigate]);

    // Фильтрация
    const filteredPrices = prices.filter(p => {
        const model = models.find(m => m.id === p.modelId);
        const brand = brands.find(b => b.id === model?.brandId);
        const year = years.find(y => y.id === p.yearId);

        const matchesBrand = brand?.name.toLowerCase().includes(filterBrand.toLowerCase());
        const matchesModel = model?.name.toLowerCase().includes(filterModel.toLowerCase());
        const matchesYear = year?.year.toString().includes(filterYear);
        const matchesPrice = p.price.toString().includes(filterPrice);

        return matchesBrand && matchesModel && matchesYear && matchesPrice;
    });

    // Получение данных
    const fetchData = async () => {
        try {
            const [brandsRes, modelsRes, yearsRes, pricesRes] = await Promise.all([
                fetch(`${config.apiUrl2}/api/auto/brands`),
                fetch(`${config.apiUrl2}/api/auto/models`),
                fetch(`${config.apiUrl2}/api/auto/years`),
                fetch(`${config.apiUrl2}/api/auto/prices`),
            ]);

            const [brandsData, modelsData, yearsData, pricesData] = await Promise.all([
                brandsRes.json(),
                modelsRes.json(),
                yearsRes.json(),
                pricesRes.json(),
            ]);

            setBrands(brandsData);
            setModels(modelsData);
            setYears(yearsData);
            setPrices(pricesData);
        } catch (error) {
            console.error('Ошибка загрузки данных:', error);
        }
    };

    // Загрузка Excel
    const handleUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);
        setUploading(true);

        try {
            const res = await fetch(`${config.apiUrl2}/api/auto/import-cars-templates`, {
                method: 'POST',
                body: formData,
            });

            if (!res.ok) throw new Error('Ошибка загрузки файла');

            alert('Файл успешно загружен');
            fetchData();
        } catch (err) {
            alert('Ошибка загрузки: ' + err.message);
        } finally {
            setUploading(false);
        }
    };

    // 📥 Скачать Excel
    const handleDownload = async () => {
        try {
            const response = await fetch(`${config.apiUrl2}/api/auto/download-car-prices`, {
                method: 'GET',
            });

            if (!response.ok) {
                throw new Error('Ошибка скачивания файла');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'car_prices.xlsx';
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (err) {
            alert('Ошибка скачивания: ' + err.message);
        }
    };

    return (
        <div className="user-mng-page">
            <header className="header">
                <NavBarAdmin />
            </header>

            <div className="profile-container">
                <h2>Импорт Excel шаблона автомобилей</h2>
                <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
                    <input type="file" accept=".xlsx" onChange={handleUpload} disabled={uploading} />
                    <button
                        onClick={handleDownload}
                        style={{ background: 'green', color: 'white', padding: '5px 10px', cursor: 'pointer' }}
                    >
                        📥 Скачать Excel
                    </button>
                </div>
                {uploading && <p>Загрузка...</p>}

                <h3>Фильтр по шаблонам автомобилей</h3>
                <div className="filters-container">
                    <input
                        type="text"
                        placeholder="Марка"
                        value={filterBrand}
                        onChange={e => setFilterBrand(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Модель"
                        value={filterModel}
                        onChange={e => setFilterModel(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Год"
                        value={filterYear}
                        onChange={e => setFilterYear(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Цена"
                        value={filterPrice}
                        onChange={e => setFilterPrice(e.target.value)}
                    />
                    <button onClick={() => {
                        setFilterBrand('');
                        setFilterModel('');
                        setFilterYear('');
                        setFilterPrice('');
                    }}>🔄 Сбросить</button>
                </div>

                <h3>Шаблоны автомобилей</h3>
                <table className="history-table">
                    <thead>
                    <tr>
                        <th>Марка</th>
                        <th>Модель</th>
                        <th>Год</th>
                        <th>Цена (сум)</th>
                    </tr>
                    </thead>
                    <tbody>
                    {filteredPrices.map(p => {
                        const model = models.find(m => m.id === p.modelId);
                        const brand = brands.find(b => b.id === model?.brandId);
                        const year = years.find(y => y.id === p.yearId);

                        return (
                            <tr key={p.id}>
                                <td>{brand?.name || '—'}</td>
                                <td>{model?.name || '—'}</td>
                                <td>{year?.year || '—'}</td>
                                <td>{p.price.toLocaleString()} сум</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default CarTemplatesManagementPage;
